{
    "SidebarMenu_Reporting_Reporting": "Relatórios",
    "SidebarMenu_Reporting_Insights": "Percepções",
    "SidebarMenu_Reporting_Presence": "Presença",
    "SidebarMenu_FastProvisioning_EnterpriseManagement": "Adicionar Empresa Empresarial +",
    "SidebarMenu_FastProvisioning_UserManagement": "Gerenciamento de usuários",
    "SidebarMenu_FastProvisioning_QueueManagement": "Gerenciamento de filas",
    "SidebarMenu_Admin_Devices": "Dispositivos",
    "SidebarMenu_Admin_Agents": "Agentes",
    "SidebarMenu_Admin_Directory": "Diretório",
    "SidebarMenu_Admin_Codes": "Códigos",
    "SidebarMenu_Admin_Partitions": "Partições",
    "SidebarMenu_Admin_TelephonyServers": "Servidores de Telefonia",
    "SidebarMenu_Admin_CME": "CME",
    "SidebarMenu_Admin_AppUsers": "Usuários",
    "SidebarMenu_Admin_Recording": "Gravação",
    "SidebarMenu_Admin_Messages": "Mensagens",
    "SidebarMenu_Admin_Database": "Banco de dados",
    "SidebarMenu_StatusTools_Licences": "Licenças",
    "SidebarMenu_StatusTools_Logging": "Registro",
    "SidebarMenu_StatusTools_LogManagement": "Gerenciamento de Logs",
    "SidebarMenu_StatusTools_AuditTrail": "Trilha de auditoria",
    "SidebarMenu_StatusTools_TelephoneModuleStatus": "Status do módulo TelSys",
    "SidebarMenu_StatusTools_CallControl": "Controle de chamadas",
    "SidebarMenu_StatusTools_ServerStatus": "Status do servidor",
    "NAME": "SidebarMenu",
    "SidebarMenu_Admin_ClientConfig": "Configuração do cliente",
    "SidebarMenu_Admin_CRM_Configuration": "Configuração de CRM"
}